export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 5_07.a5e0a427.jpg";